import { SideNavLinkItem } from "@snapchat/snap-design-system";
import { DoubleChevronRightIcon, DoubleChevronLeftIcon } from "@snapchat/snap-design-system-icons";
import { FC, useMemo } from "react";
import { useLocation, Link } from "react-router-dom";
import { Flexbox } from "../Flexbox";
import { containerPadding, linkStyle, previousStyle, stepperLinkStyle, stepperText } from "./NavigationStepper.styles";

export const NavigationStepper: FC<{ routeItems: SideNavLinkItem[] }> = ({ routeItems }) => {
    const location = useLocation();
    const [previous, next] = useMemo(() => {
        const currentIndex = routeItems.findIndex(({ itemKey }) => `/${itemKey}` === location.pathname);

        return [routeItems[currentIndex - 1] || undefined, routeItems[currentIndex + 1] || undefined];
    }, [location.pathname, routeItems]);

    return (
        <Flexbox css={containerPadding}>
            <Flexbox
                css={[stepperLinkStyle, previousStyle]}
                style={{ visibility: !previous ? "hidden" : undefined }}
                flex="1 50%"
                alignItems="center"
            >
                {previous ? (
                    <Link css={linkStyle} to={previous?.itemKey}>
                        <div>Previous</div>
                        <div css={stepperText}>
                            <DoubleChevronLeftIcon size={12} />
                            {previous?.text}
                        </div>{" "}
                    </Link>
                ) : undefined}
            </Flexbox>
            <Flexbox
                css={stepperLinkStyle}
                flex="1 50%"
                alignItems="center"
                style={{ visibility: !next ? "hidden" : undefined }}
            >
                {next ? (
                    <Link css={linkStyle} to={next?.itemKey}>
                        <div>Next</div>
                        <div css={stepperText}>
                            {next?.text}
                            <DoubleChevronRightIcon size={12} />
                        </div>
                    </Link>
                ) : undefined}
            </Flexbox>
        </Flexbox>
    );
};
